import React from "react";
import moment from "moment";
import { Button } from "primereact/button";

import CartItems from "./CartItems";
import ShippingAddressCards from "../../../../common/ShippingAddressCards";


const Checkout = (props) =>{
    const { 
        setVisibleCheckout, 
        branchId,
        cartItems,
        updateCartItems,
        handleSubmit,
        cartSubmitRef,
        catalogApiRequest,
        selectedShipAddrId,
        setSelectedShipAddrId,
        shippingAddresses
    } = props

    const handleShippingAddress = (addrId) => {
        setSelectedShipAddrId(addrId)
    }

    const addEscapeCharacters = (str) => {
        str = str.replace(/\&/g, '&amp;');
        str = str.replace(/</g, '&lt;');
        str = str.replace(/>/g, '&gt;');
        str = str.replace(/\"/g, '&quot;');
        str = str.replace(/\'/g, '&#039;');
        return str
    }

    const constructSAPResponse = () => {
        let totalPrice = 0

        cartItems?.map(eachCartItem => {
            totalPrice += parseFloat(eachCartItem.unitPrice * eachCartItem.quantity, 2)
        })

        const catelogueAPIRequest = ''
        const companyId = ''

        const URL = catalogApiRequest?.redirectionURL // "https://s1-2.ariba.com/Buyer/punchout?client=HTML.DC30800780239FBA5289A27B7E67282C.Node14app987snv&responseid=1c&locale=en_US" //catalogApiRequest?.redirectionURL
        const BUYER_COOKIE = catalogApiRequest?.buyerCookie
        const PAYLOAD_ID = catalogApiRequest?.payloadId
        const TO_NETWID = catalogApiRequest?.toNetworkId
        const FROM_NETWID = catalogApiRequest?.fromNetworkId
        const TIMESTAMP = moment(new Date()).format('YYYY-MM-DDThh:mm:ss-hh:mm')

        let items = ''

        let emptyProductList = false
        if (cartItems.length == 0) {
            emptyProductList = true
        }

        if (!companyId) {
            cartItems.map((prod, key) => {
                let specifications = addEscapeCharacters(prod.companyProdSpec)
                items = items + `<ItemIn quantity="${prod.quantity}">
                    <ItemID>
                        <SupplierPartID>${prod.buyerRateContractId}</SupplierPartID>
                        <SupplierPartAuxiliaryID>${catalogApiRequest?.catalogApiRequestId}</SupplierPartAuxiliaryID>
                    </ItemID>
                    <ItemDetail>
                        <UnitPrice>
                        <Money currency="INR">${prod.unitPrice}</Money>
                        </UnitPrice>
                        <Description xml:lang="en-US">${specifications}</Description>
                        <UnitOfMeasure>${prod.companyERPUOM}</UnitOfMeasure>
                        <Classification domain="UNSPSC">${prod.UNSPSC}</Classification>
                        <ManufacturerPartID />
                        <ManufacturerName />
                        <LeadTime>${prod.leadTime}</LeadTime>
                        <Extrinsic name="cus_HSN">${prod.companyHSNOverride}</Extrinsic>
                    </ItemDetail>
                    </ItemIn>\n`
            })
        }
        else {
            cartItems.map((prod, key) => {
                let specifications = addEscapeCharacters(prod.companyProdSpec)
                items = items + `<ItemIn quantity="${prod.quantity}">
                    <ItemID>
                        <SupplierPartID>${prod.buyerRateContractId}</SupplierPartID>
                        <SupplierPartAuxiliaryID>${catalogApiRequest?.catalogApiRequestId}</SupplierPartAuxiliaryID>
                    </ItemID>
                    <ItemDetail>
                        <UnitPrice>
                        <Money currency="INR">${prod.unitPrice}</Money>
                        </UnitPrice>
                        <Description xml:lang="en-US">${specifications}</Description>
                        <UnitOfMeasure>${prod.companyERPUOM}</UnitOfMeasure>
                        <Classification domain="UNSPSC">${prod.unspsc}</Classification>
                        <ManufacturerPartID />
                        <ManufacturerName />
                        <LeadTime>${prod.leadTime}</LeadTime>
                    </ItemDetail>
                    </ItemIn>\n`
            })
        }

        const requestBody = `<?xml version="1.0" encoding="UTF-8"?>
            <!DOCTYPE cXML SYSTEM "http://xml.cxml.org/schemas/cXML/1.2.014/cXML.dtd">
            <cXML payloadID="${PAYLOAD_ID}" xml:lang="en-US" timestamp="${TIMESTAMP}" version="1.2.0.14">
            <Header>
                <From>
                <Credential domain="NetworkID">
                <Identity>${FROM_NETWID}</Identity>
                </Credential>
                        </From>
                        <To>
                <Credential domain="NetworkId">
                <Identity>${TO_NETWID}</Identity>
                </Credential>
                        </To>
                        <Sender>
                <Credential domain="NetworkID">
                <Identity />
                </Credential>
                        <UserAgent />
                        </Sender>
                    </Header>
                    <Message deploymentMode="production">
                        <PunchOutOrderMessage>
                        <BuyerCookie>${BUYER_COOKIE}</BuyerCookie>
                        <PunchOutOrderMessageHeader operationAllowed="edit" quoteStatus="final">
                        <Total>
                            <Money currency="INR">${totalPrice}</Money>
                        </Total>
                        </PunchOutOrderMessageHeader>
                            ${items}
                        </PunchOutOrderMessage>
            </Message>
            </cXML>`

        return {requestBody, URL}
    }

    const {requestBody, URL} = constructSAPResponse()

    console.log("URL", URL)
    console.log("request_body", requestBody)

    return(
        <div className="flex flex-column justify-content-between">
            <CartItems 
                cartItems={cartItems}
                updateCartItems={updateCartItems}
            />
            <p className="mt-3 text-base font-semibold">Shipping Address</p>
            <ShippingAddressCards shippingAddresses={shippingAddresses} selectedAddressId={selectedShipAddrId} handleShippingAddress={handleShippingAddress} />
            <div className="flex justify-content-end">
                <form id="cxml_form" method="POST" action={ URL } enctype="application/x-www-form-urlencoded"> {/*   */}
                    <input type="hidden" name="cXML-urlencoded" value={ requestBody }/>
                    <button type="submit" ref={cartSubmitRef} />
                    <button className="submit-btn" id="" onClick={handleSubmit} disabled={!cartItems.length || branchId === "0"}>Submit</button>
                </form>
                <Button className="ml-2" label="CANCEL" outlined severity="danger" onClick={() => setVisibleCheckout(false)} />
            </div>
        </div>
    )
}

export default Checkout;